import type { MonospaceOrgSettings } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { SINGLETON_KEY } from '#layers/workspace/public';

export const OrgSettings = RStoreSchema.withItemType<MonospaceOrgSettings>().defineCollection({
	getKey: () => SINGLETON_KEY,
	name: 'MonospaceOrgSettings',
	scopeId: 'monospace-default',
	meta: {
		singleton: true,
		defaultFields: ['name', 'color', 'logoId'],
		endpoint: 'system/settings',
	},
});
